import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/portfolio")({
  head: () => ({ meta: [{ title: "Portfolio | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-portfolio")),
});
